import {  Component, ComponentFactoryResolver,  OnDestroy,  OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { PilotageEndelComponent } from 'frontEndelScreens/PILOTAGE_ENDEL/pilotage-endel/pilotage-endel.component';
import { ApiVersion, IntUser,  PafSetting,  PilotageEndelContainerLoaderEvent,  SharedDataService } from 'ngx-paf-common';
import { ActivatedRoute, Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AccountInfo,EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';

import { filter } from 'rxjs/operators';
import { azureEnvironnent } from 'localEnvironments/environment';
import { AuthService } from 'localServices/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'paf-endel';
  isLoggedIn : boolean = false;


  private subs:Subscription[] = [];

  public get pafVersion() : ApiVersion {
    return this.sharedDataSvc.apiVersion;
  }


  constructor(
    public sharedDataSvc: SharedDataService,
    public router:Router,
    private activatedRoute: ActivatedRoute,
    private componentFactoryResolver: ComponentFactoryResolver,    
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private authSvc: AuthService) {
  }
  
  ngOnDestroy(): void {
    this.subs.forEach(s=>s.unsubscribe());
  }


   async ngOnInit() {
    this.subs.push(this.sharedDataSvc.loggedIntUserChange.subscribe({
      next: async (intUser: IntUser | undefined) => {
        if (intUser) {
          this.sharedDataSvc.authToken = await this.authSvc.getValidToken();
        }
      }
    }));
    this.isLoggedIn = this.msalService.instance.getAllAccounts().length > 0;
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
      )
      .subscribe(() => {
        this.isLoggedIn = true;
        this.sharedDataSvc.loggedId = this.getUserId();
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None)
      )
      .subscribe( () => {
        this.isLoggedIn = this.msalService.instance.getAllAccounts().length > 0;
        if (this.isLoggedIn) {
          this.sharedDataSvc.loggedId = this.getUserId();   
        }
      });
  }

get intUser():IntUser | undefined{
  return this.sharedDataSvc.loggedIntUser;
}

public get pafSettings(): PafSetting[] | undefined {
  return this.sharedDataSvc.pafSettings;
} 
  public get loggedUsername(): string {
    return (this.intUser==undefined) ? '' : this.intUser.Contact?.Firstname + ' ' + this.intUser?.Contact?.Lastname;
  }
  
  
  getUserId(): string | null {
    const account: AccountInfo | null = this.msalService.instance.getActiveAccount()
      ?? this.msalService.instance.getAllAccounts()[0];
    if (account && account.idTokenClaims) {
      return (account.idTokenClaims as any).preferred_username;
    }
    return null;
  }
  

  ngAfterViewInit(): void {
    this.sharedDataSvc.mainContainerRef = this.mainContainerRef;
    this.sharedDataSvc.loadPilotageEndel.subscribe((value: PilotageEndelContainerLoaderEvent) => this.loadPilotageEndel(value));
    // this.intUser = this.sharedDatasSvc.loggedIntUser;
    // this.sharedDatasSvc.loggedIntUserChange.subscribe(res=>this.intUser = res);
  }

  private loadPilotageEndel(value: PilotageEndelContainerLoaderEvent) {
    const viewContainerRef = value.container.viewContainerRef;
    viewContainerRef.clear();
    let factory = this.componentFactoryResolver.resolveComponentFactory(PilotageEndelComponent);
    const componentRef = viewContainerRef.createComponent<PilotageEndelComponent>(factory);
    componentRef.instance.supplier = value.supplier;
  }

  @ViewChild('mainContainer', { read: ViewContainerRef }) public mainContainerRef: ViewContainerRef;
  
clearCache():void{
    this.sharedDataSvc.WindowLock();
    this.sharedDataSvc.clearServerCache().subscribe({
      next:()=>this.sharedDataSvc.informe(this.sharedDataSvc.lngCod=='EN' ? 'Cache cleared':'Cache réinitialisé',null,'success'),
      error:(err:any)=>this.sharedDataSvc.alert(this.sharedDataSvc.lngCod=='EN' ? 'Error clearing cache':'Erreur lors de la réinitialisation du cache.',null,'error'),
      complete:()=>this.sharedDataSvc.WindowUnlock()
    });
  }
}
